import React from 'react'
import WallsImg from '../../../assets/images/information/utility.png'

const InfoWalls = () => {
  return (
    <div>
        <div className='content-text'>
            The walls of your building can be customized here with gables and extra paneling. Remember to check the option for J-Trim if you add any gable-end enclosures or extra panels. <br/><br/>The siding material is provided based on the manufacturer's offerings and the available panel orientation. <br/><br/> With the walls, you can add <span>utility storage</span> on the front, back, left, or right side of the building.
        </div>
        <div className='mt-3'>
            <img src={process.env.REACT_APP_BASE_URL+WallsImg} className='general-img' alt='walls'/>
        </div>
    </div>
  )
}

export default InfoWalls